import React from "react";
import * as FaIcons from "react-icons/fa";
import * as FcIcons from "react-icons/fc";
import * as Fa6Icons from "react-icons/fa6";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import * as BSIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";
import * as GiIcons from "react-icons/gi";
import * as BsIcons from "react-icons/bs";
import * as CgIcons from "react-icons/cg";

export const SidebarData = [
// userrole is an array that contains all the role ids who are allowed to see each menu
// all menus and submenus must have the property userrole
{
	userrole: [1,2,3,4,5,6],
	title: "LISTS",	
	icon: <FaIcons.FaListAlt />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,

	subNav: [	
		{
			userrole: [1,3],
			title: "ITEMS",	
			icon: <BsIcons.BsBoxSeamFill />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/items",
		},
		{
			userrole: [2,3],
			title: "LOCATIONS",	
			icon: <MdIcons.MdLocationOn />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/locations",
		},
		{
			userrole: [1,2,3,4,5,6],
			title: "CLIENTS",	
			icon: <BSIcons.BsPersonCircle />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/clients",
		},
		{
			userrole: [1,2,3],
			title: "JOBS",	
			icon: <RiIcons.RiProjectorFill />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/jobs",
		},
		{
			userrole: [1,2,3,4,5,6],
			title: "UOMs",	
			icon: <GiIcons.GiWeight />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/uoms",
		},
		{
			userrole: [1,3],
			title: "SUPPLIERS",	
			icon: <BiIcons.BiSolidBusiness />,
			iconClosed: <RiIcons.RiArrowDownSFill />,
			iconOpened: <RiIcons.RiArrowUpSFill />,
			path: "/suppliers",
		}
	]	
},

{
	userrole: [1,2,3,4,5,6],
	title: "MOVEMENTS",
	icon: <RiIcons.RiFileTransferFill />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,

	subNav: [	
		{
			userrole: [1,2,3,4,5,6],
			title: "NEW MOVEMENT",
			path: "/new-movement",
			icon: <CgIcons.CgAdd />,
		},	
		{
			userrole: [1,2,3],
			title: "PO TRACKER",
			path: "/PO-TRACKER",
			icon: <Fa6Icons.FaBoxesPacking />,
		},	
		{
			userrole: [2,3,4],
			title: "BK REQ. TRACKER",
			path: "/bookin-request-tracker",
			icon: <BiIcons.BiSolidFactory/>,
		},
		{
			userrole: [2,3,4],
			title: "SEARCH",
			path: "/search-movement",
			icon: <FaIcons.FaSearch/>,
		}										
	]		
},
{
	userrole: [1,2,3,4],
	title: "WAREHOUSE",
	icon: <Fa6Icons.FaMoneyBill1 />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,

	subNav: [	
		{
			userrole: [3, 4],
			title: "RECEPTIONS",
			path: "/receptions",
			icon: <FcIcons.FcMoneyTransfer />,
		},
		{
			userrole: [1, 2, 3],
			title: "STOCK LOCATION",
			path: "/stocklocationview",
			icon: <FcIcons.FcMoneyTransfer />,
		},
		{
			userrole: [1, 2, 3],
			title: "STOCK BY ITEM",
			path: "/stockview",
			icon: <FcIcons.FcMoneyTransfer />,
		},
		{
			userrole: [1, 2, 3],
			title: "MINIMUM STOCKS",
			path: "/minimumstocks",
			icon: <FcIcons.FcMoneyTransfer />,
		},
		{
			userrole: [1, 2, 3],
			title: "MOVEMENTS BY ITEM",
			path: "/movements-by-item",
			icon: <FcIcons.FcMoneyTransfer />,
		}							

	]		
},
{
	userrole: [1],
	title: "DASHBOARD",
	path: "/dashboard",
	icon: <BiIcons.BiSolidDashboard />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,
},
{
	userrole: [3],
	title: "ADMIN",
	icon: <BsIcons.BsFillGearFill />,
	iconClosed: <RiIcons.RiArrowDownSFill />,
	iconOpened: <RiIcons.RiArrowUpSFill />,

	subNav: [	
		{
			userrole: [3],
			title: "SETTINGS",
			path: "/admin-settings",
			icon: <AiIcons.AiFillSetting />,
		},
		{
			userrole: [3],
			title: "MANAGE USERS",
			path: "/admin-users",
			icon: <RiIcons.RiUserSettingsFill />,
		}		
	]	
},

{
	userrole: [1],
	title: "HELP",
	path: "/help",
	icon: <IoIcons.IoMdHelpCircle />,
},
];
